var map = {
	"./1.10_Russian_road_sign.svg": "ba0b",
	"./1.11.1_Russian_road_sign.svg": "4329",
	"./1.11.2_Russian_road_sign.svg": "7113",
	"./1.12.1_Russian_road_sign.svg": "f726",
	"./1.12.2_Russian_road_sign.svg": "da51",
	"./1.13_Russian_road_sign.svg": "6e5b",
	"./1.14_Russian_road_sign.svg": "63a7",
	"./1.15_Russian_road_sign.svg": "34e3",
	"./1.16_Russian_road_sign.svg": "55e5",
	"./1.17_Russian_road_sign.svg": "5fab",
	"./1.18_Russian_road_sign.svg": "891f",
	"./1.19_Russian_road_sign.svg": "de86",
	"./1.1_Russian_road_sign.svg": "d62d",
	"./1.20.1_Russian_road_sign.svg": "5681",
	"./1.20.2_Russian_road_sign.svg": "f52f",
	"./1.21_Russian_road_sign.svg": "b4b7",
	"./1.22_Russian_road_sign.svg": "b50d",
	"./1.23_Russian_road_sign.svg": "34b4",
	"./1.24_Russian_road_sign.svg": "a005",
	"./1.25_Russian_road_sign.svg": "3abf4",
	"./1.27_Russian_road_sign.svg": "0d50",
	"./1.28_Russian_road_sign.svg": "07bd",
	"./1.29_Russian_road_sign.svg": "1f2d",
	"./1.2_Russian_road_sign.svg": "82d7",
	"./1.30_Russian_road_sign.svg": "f710",
	"./1.31_Russian_road_sign.svg": "81f2",
	"./1.32_Russian_road_sign.svg": "d8fa",
	"./1.33_Russian_road_sign.svg": "a101",
	"./1.5_Russian_road_sign.svg": "a926",
	"./1.6_Russian_road_sign.svg": "1d1a",
	"./1.7_Russian_road_sign.svg": "c815",
	"./1.8_Russian_road_sign.svg": "220f",
	"./1.9_Russian_road_sign.svg": "05c6",
	"./2.1_Russian_road_sign.svg": "7182",
	"./2.2_Russian_road_sign.svg": "b8f5",
	"./2.4_Russian_road_sign.svg": "8c6a",
	"./2.5_Russian_road_sign.svg": "fc58",
	"./2.6_Russian_road_sign.svg": "de4d",
	"./2.7_Russian_road_sign.svg": "9375",
	"./3.1_Russian_road_sign.svg": "bbbc",
	"./3.27_Russian_road_sign.svg": "24d9",
	"./3.28_Russian_road_sign.svg": "9bd7",
	"./3.29_Russian_road_sign.svg": "502b",
	"./3.2_Russian_road_sign.svg": "28f2",
	"./3.30_Russian_road_sign.svg": "a2fa",
	"./3.31_Russian_road_sign.svg": "fa73",
	"./3.3_Russian_road_sign.svg": "ab17",
	"./3.4_Russian_road_sign.svg": "4388",
	"./3.5_Russian_road_sign.svg": "bf3b",
	"./3.6_Russian_road_sign.svg": "5f01",
	"./4.5.1_Russian_road_sign.svg": "19fe",
	"./4.6_Russian_road_sign.svg": "8c3e",
	"./bicycle-blue.svg": "5e0e",
	"./bicycle-green.svg": "78ce",
	"./bicycle-orange.svg": "f098",
	"./bicycle-purple.svg": "9a7d3",
	"./bicycle-red.svg": "9cbc",
	"./bus-blue.svg": "5b95",
	"./bus-green.svg": "5659",
	"./bus-orange.svg": "2e9a",
	"./bus-purple.svg": "6e5c",
	"./bus-red.svg": "382d",
	"./bus-station-blue.svg": "35a9",
	"./bus-station-green.svg": "a1dd",
	"./bus-station-orange.svg": "9518",
	"./bus-station-purple.svg": "3d7a",
	"./bus-station-red.svg": "1418",
	"./car-blue.svg": "23d8",
	"./car-green.svg": "5174",
	"./car-orange.svg": "898d",
	"./car-purple.svg": "4776",
	"./car-red.svg": "1649",
	"./car_icon.svg": "f8ee",
	"./circle-blue.svg": "ef92",
	"./circle-green.svg": "7a27",
	"./circle-orange.svg": "921b",
	"./circle-purple.svg": "a76a",
	"./circle-red.svg": "2489",
	"./flag-blue.svg": "b438",
	"./flag-green.svg": "4bfe",
	"./flag-orange.svg": "ccfe",
	"./flag-purple.svg": "2d95",
	"./flag-red.svg": "9c74",
	"./marker-blue.svg": "3ef8",
	"./marker-green.svg": "3562",
	"./marker-orange.svg": "af94",
	"./marker-purple.svg": "81cf",
	"./marker-red.svg": "6bb8",
	"./motorcycle-blue.svg": "dc43",
	"./motorcycle-green.svg": "3de2",
	"./motorcycle-orange.svg": "960c",
	"./motorcycle-purple.svg": "4e95",
	"./motorcycle-red.svg": "d2ce",
	"./rhombus-blue.svg": "2971",
	"./rhombus-green.svg": "fe76",
	"./rhombus-orange.svg": "a4d0",
	"./rhombus-purple.svg": "cea4",
	"./rhombus-red.svg": "aa32",
	"./sensor-blue.svg": "d9ef",
	"./sensor-green.svg": "916a",
	"./sensor-orange.svg": "5572",
	"./sensor-purple.svg": "846e",
	"./sensor-red.svg": "72d2",
	"./square-blue.svg": "224e",
	"./square-green.svg": "0b02",
	"./square-orange.svg": "1ad1",
	"./square-purple.svg": "e3ad",
	"./square-red.svg": "cc4b",
	"./tram-blue.svg": "a4ba",
	"./tram-green.svg": "e7e7",
	"./tram-orange.svg": "c210",
	"./tram-purple.svg": "978a",
	"./tram-red.svg": "f20b",
	"./truck-blue.svg": "948b",
	"./truck-green.svg": "c7e8",
	"./truck-orange.svg": "c545",
	"./truck-purple.svg": "6d9f",
	"./truck-red.svg": "69a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa7f";